export default __webpack_public_path__ + "static/media/loginRightImg.fc2dd657.svg";